import { FC, useState } from 'react';
import { BaseCampaignStep } from '../BaseCampaignStep';
import { SelectTraitsStep, SetupDestinationConnection, CongratulationStep } from './steps';
import { useFormContext } from 'react-hook-form';
import { CreateCampaignFormInput } from '../../../validation';
import { useTranslation } from 'react-i18next';

type TConnectAudienceStep = 'SetupDestination' | 'SelectTrait' | 'Congratulation';

export const ConnectAudienceStep: FC = () => {
  const { t } = useTranslation();
  const [currentConnectAudienceStep, setCurrentConnectAudienceStep] = useState<TConnectAudienceStep>('SetupDestination');

  const toNextStep = () => {
    setCurrentConnectAudienceStep(() => {
      if (currentConnectAudienceStep === 'SetupDestination') {
        return 'SelectTrait';
      } else if (currentConnectAudienceStep === 'SelectTrait') {
        return 'Congratulation';
      }

      throw new Error('cannot_go_next');
    });
  };

  const toPreviousStep = () => {
    setCurrentConnectAudienceStep(() => {
      if (currentConnectAudienceStep === 'SelectTrait') {
        return 'SetupDestination';
      }

      throw new Error('cannot_go_back');
    });
  };

  const { watch } = useFormContext<CreateCampaignFormInput>();

  const connectors = watch('connectors');
  const audience = watch('audience');

  if (!connectors || connectors.length === 0 || !audience) {
    return (
      <>
        <div className='mx-auto max-w-md rounded-r-lg border-l-4 border-brand-400 bg-blue-50 p-4 shadow-sm'>
          <h3 className='mb-2 text-sm font-semibold text-brand-900'>{t('ALL:impossibleMoveForward')}</h3>
          <p className='text-sm font-medium text-brand-800'>{t('campaign:makeSureDestinationAndAudiencesSelected')}</p>
        </div>
      </>
    );
  }

  return (
    <BaseCampaignStep>
      {currentConnectAudienceStep === 'SetupDestination' && <SetupDestinationConnection toNextStep={toNextStep} toPreviousStep={toPreviousStep} />}
      {currentConnectAudienceStep === 'SelectTrait' && <SelectTraitsStep toNextStep={toNextStep} toPreviousStep={toPreviousStep} />}
      {currentConnectAudienceStep === 'Congratulation' && <CongratulationStep />}
    </BaseCampaignStep>
  );
};
